'use strict';/* global require:false */require(['require-config'],function(){'use strict';require(['angular','helen'],function(ng){// angular patch for exception handling in fromJson-method
var ngFromJson=ng.fromJson;ng.fromJson=function(json){var data=null;try{data=ngFromJson(json);}catch(err){throw new Error('JSON.parse failed to parse this: '+JSON.stringify({data:json}));}return data;};// bootstrap
ng.bootstrap(document,['helen']);});});
define("boot", function(){});

